import React from 'react';
import { SVGProps } from './SVGProps';
import classnames from 'classnames';
/**
 * Info SVG component
 *
 * @returns
 */
function InfoSVGAlternative({ className, ...rest }: SVGProps) {
	return (
		<svg
			viewBox="0 0 24 24"
			className={classnames('roc-icon', className)}
			focusable="false"
			aria-hidden="true"
			{...rest}
		>
			<path d="M12,2.24A9.76,9.76,0,1,1,2.24,12,9.77,9.77,0,0,1,12,2.24M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Z" />
			<polygon points="13 11 11 11 11 19 13 19 13 11 13 11" />
			<path d="M12,6a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,12,6Z" />
		</svg>
	);
}
export default InfoSVGAlternative;
